export enum TrackingCreativePrefix {
    PageTile = 'PageTile',
    PageSlider = 'PageSlider',
}
